import { Link } from "react-router-dom";
import type { ShopifyOrderView, WebOrderAttentionReason } from "../../api/types";
import { REASON_LABEL, reasonDetail, toneClass } from "./webOrderAttention";

/**
 * G-160 (OD-263) — on a web order's card: each reason it needs someone, in a
 * line, with the way out that is not already on the card. Transfers, Re-check,
 * Acknowledge, Accept and the per-line "link it" stay where they were.
 */
export function WebOrderAttentionBox({ order }: { order: ShopifyOrderView }) {
  if (!order.attention.length) return null;
  return (
    <ul className="wo-attn-box">
      {order.attention.map((reason) => (
        <li key={reason}>
          <span className={toneClass(reason)}>{REASON_LABEL[reason]}</span>
          <span className="wo-attn-detail">{reasonDetail(order, reason)}</span>
          <ReasonLinks order={order} reason={reason} />
        </li>
      ))}
    </ul>
  );
}

function ReasonLinks({ order, reason }: { order: ShopifyOrderView; reason: WebOrderAttentionReason }) {
  const shopify = order.adminUrl ? (
    <a href={order.adminUrl} target="_blank" rel="noopener noreferrer">
      Open in Shopify
    </a>
  ) : null;
  switch (reason) {
    case "CANT_BE_MADE":
      return (
        <span className="wo-attn-links">
          <Link to="/app/deliveries">Receive stock</Link>
          <Link to="/app/inventory">Move stock</Link>
          {shopify}
        </span>
      );
    case "NOT_LINKED":
    case "NOTHING_LINKED":
      return (
        <span className="wo-attn-links">
          <Link to="/app/shopify/products">Link products</Link>
          {shopify}
        </span>
      );
    case "DELIVERY_FAILED":
      return (
        <span className="wo-attn-links">
          <Link to="/app/dispatch">Courier board</Link>
        </span>
      );
    case "MULTI_BOUQUET_LINE":
      return <span className="wo-attn-links">{shopify}</span>;
    default:
      return null;
  }
}
